angular.module('agreements')
    .component('agreementOrderList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/agreements/list-order.html',
        controller: function ($scope, $state, $stateParams, Agreement, AgreementService, AgreementConst) {
            this.AgreementService = AgreementService
            this.types = AgreementService.getTypes('ORDER')
            this.reset = () => this.filters = {}
            $scope.$on(AgreementConst.eventUpdate, () => $state.reload())
            $scope.$on("file.saved", () => $state.reload())
        }
    })
